import React from 'react';
import { Link } from 'react-router-dom';
import { BadgeCheck, MapPin, Users } from 'lucide-react';
import { RatingStars } from './RatingStars';
import { PlanBadge } from './PlanBadge';
import { fileUrl } from '../../lib/upload';

export function StoreCard({ merchant }) {
  const isDirectory = merchant.plan === 'LIST';
  const to = isDirectory ? `/business/${merchant.slug}` : `/store/${merchant.slug}`;
  return (
    <Link
      to={to}
      data-testid={`store-card-${merchant.slug}`}
      className="group flex flex-col rounded-3xl bg-kelate-surface p-2.5 shadow-[0_1px_4px_rgba(81,68,55,0.08)] transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_10px_28px_rgba(81,68,55,0.14)]"
    >
      <div className="relative h-24 overflow-hidden rounded-2xl bg-[#EFEAE2]">
        {merchant.banner && <img src={fileUrl(merchant.banner)} alt="" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" />}
      </div>
      <div className="flex items-start gap-3 px-2.5 pb-2 pt-3">
        {merchant.logo ? (
          <img src={fileUrl(merchant.logo)} alt={merchant.name} className="aspect-square h-14 w-14 shrink-0 rounded-2xl border border-kelate-line object-cover" />
        ) : (
          <span className="flex aspect-square h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-kelate-darkwood font-display text-lg font-semibold text-kelate-surface">{merchant.name[0]}</span>
        )}
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-1.5">
            <span className="truncate text-sm font-semibold text-kelate-ink">{merchant.name}</span>
            {merchant.verified && <BadgeCheck size={14} className="shrink-0 text-kelate-sage" />}
          </div>
          <div className="mt-0.5 flex items-center gap-2">
            <RatingStars rating={merchant.rating} />
            <span className="flex items-center gap-0.5 text-[11px] text-kelate-soft"><Users size={10} />{merchant.followers}</span>
          </div>
          <div className="mt-1.5 flex items-center justify-between">
            <span className="flex items-center gap-1 text-[11px] text-kelate-soft"><MapPin size={10} />{merchant.district}</span>
            <PlanBadge plan={merchant.plan} />
          </div>
        </div>
      </div>
    </Link>
  );
}
